export default __webpack_public_path__ + "static/media/eggbox1.3e21740a.webp";